<button matIconButton aria-label="Annuler" title="Annuler">
  <svg lucideX></svg>
</button>
